export default resultTabs => {
    if ($('.responsive-tabs').length < 1) {
        return false;
    }

    let $tabs = $('.responsive-tabs-title');

    $tabs.on('click', event => {
        let $tab = $(event.currentTarget);
        let $target = $(`[data-tab-target=${$tab.find('> a').data('show')}]`);

        if ($tab === $('.responsive-tabs-title.is-active')) {
            return;
        }

        $tabs.removeClass('is-active').attr('aria-selected', 'false');
        $tab.addClass('is-active').attr('aria-selected', 'true');

        $('[data-tab-target]').removeClass('is-active');
        $target.addClass('is-active');

        return false;
    });
};